import { render, staticRenderFns } from "./AddPayment.vue?vue&type=template&id=b06f13d8&"
import script from "./AddPayment.vue?vue&type=script&lang=js&"
export * from "./AddPayment.vue?vue&type=script&lang=js&"
import style0 from "./AddPayment.vue?vue&type=style&index=0&id=b06f13d8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports